import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "@air/primitive-avatar";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { formatInitials } from "@air/utilities";
import Router from "next/router";
import { memo, useMemo } from "react";
import { Routes } from "~/constants/routes";
import { formatFullName } from "~/utils/formatFullName";
import { getAvatarImageSrc } from "~/utils/getAvatarImageSrc";
export const PublicTopBarMobileAccountInfo = /*#__PURE__*/ memo((param)=>{
    let { account: { lastName, firstName, email, avatar, id }, canCreateAccount } = param;
    const fullName = formatFullName(firstName, lastName);
    const initials = formatInitials(firstName, lastName);
    const options = useMemo(()=>{
        const options = [
            {
                id: "account-name",
                type: "children",
                children: /*#__PURE__*/ _jsxs("p", {
                    className: "truncate text-14 text-grey-12",
                    children: [
                        fullName,
                        " (",
                        email,
                        ")"
                    ]
                })
            }
        ];
        if (canCreateAccount) {
            options.push({
                id: "create-account",
                type: "item",
                label: "Create account",
                onSelect: ()=>{
                    Router.push("".concat(Routes.auth.signUp, "?email=").concat(encodeURIComponent(email)));
                }
            });
        }
        return options;
    }, [
        fullName,
        email,
        canCreateAccount
    ]);
    const trigger = useMemo(()=>/*#__PURE__*/ _jsx("button", {
            children: /*#__PURE__*/ _jsx(Avatar, {
                alt: "".concat(fullName, " avatar"),
                colorSeed: id,
                size: 24,
                src: getAvatarImageSrc(avatar, 24),
                text: initials
            })
        }), [
        avatar,
        fullName,
        id,
        initials
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        size: "small",
        className: "shrink-0",
        trigger: trigger,
        children: renderDropdownItems({
            options,
            size: "small"
        })
    });
});
PublicTopBarMobileAccountInfo.displayName = "PublicTopBarAccountInfo";
